import { Quill } from 'react-quill';

let isConfigured = false;

export const configureReactQuillBlockTag = () => {
  if (isConfigured) {
    return;
  }

  const Block = Quill.import('blots/block');
  Block.tagName = 'DIV';
  Quill.register(Block, true);
  isConfigured = true;
};
